export default "__VITE_ASSET__DCKBVqxy__"